/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React, { useContext, useEffect } from 'react';
import { track } from '../../../analytics/analytics';
import { EventIDs } from '../../../analytics/events';
import { GREEN_CHECK_MARK } from '../../../constants/urls';
import { useGlobalState } from '../../context/qrState';
import { UserContext } from '../../context/userContext';
import {
  Container,
  Img,
  Text,
  Details,
  OkayBtn,
  FeedbkContainer,
} from './styles';

const SuccessLayout = () => {
  const [showSuccessLayout, setShowSuccessLayout] = useGlobalState(
    'feedBackSuccess'
  );
  const { email } = useContext<Record<string, any>>(UserContext);

  useEffect(() => {
    if (showSuccessLayout) {
      const payload = {
        email,
      };
      track(EventIDs.FEEDBACK_SUCCESS, payload);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSuccessLayout]);

  const okayBtnClick = () => {
    setShowSuccessLayout(false);
    const payload = {
      email,
    };
    track(EventIDs.FEEDBACK_OKAY, payload);
  };

  return (
    <>
      {showSuccessLayout && (
        <>
          <Container>
            <FeedbkContainer>
              <Img src={GREEN_CHECK_MARK} alt="" />
              <Text>Thank you!</Text>
              <Details>
                <span>Your valuable feedback helps us make the</span>
                <span>app more useful for everyone.</span>
              </Details>
              <OkayBtn onClick={okayBtnClick}>okay</OkayBtn>
            </FeedbkContainer>
          </Container>
        </>
      )}
    </>
  );
};
export default SuccessLayout;
